export function gameViewClientStorageKey(campaignId) {
  return `game-view-client:${campaignId}`;
}

export function resolveGameViewClientId(campaignId) {
  const key = gameViewClientStorageKey(campaignId);
  const existing = sessionStorage.getItem(key);
  if (existing) return existing;

  const clientId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  sessionStorage.setItem(key, clientId);
  return clientId;
}
